<template>
	<span>
		<v-container fluid fill-height class="home-hero" style="max-height: 50vh;">
			<v-row align-center justify-center fill-height>
				<v-col class="font-weight-white text-center white--text headline">
					<h1>مدیریتی قوی با ابزاری نوین</h1>
				</v-col>
			</v-row>
		</v-container>
	</span>
</template>

<script>
	export default {
		name: "HomeHero",
	};
</script>

<style scoped>
	.home-hero {
		background: url("~@/assets/img/product-hero.jpg");
		background-size: cover;
		width: 100%;
		height: 100%;
	}
</style>
